var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-logo minimal"},[_c('img',{staticClass:"logo",attrs:{"src":_vm._f("staticPath")(_vm.logo),"alt":"Logo"}})])}
var staticRenderFns = []

export { render, staticRenderFns }